import { useState } from "react";
import { Button, Modal } from "antd";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { updateAdminStatus } from "../../../api/auth";
import { usePermissionEffect } from "../../../utils/usePermissionEffect";

// Activates or deactivates an admin. A role can only be deleted once every
// admin on it is deactivated. Renders nothing without Admin: canUpdate.
export default function AdminStatusButton({ admin }) {
  const queryClient = useQueryClient();
  const { getModulePermission } = usePermissionEffect();
  const [open, setOpen] = useState(false);
  const isActive = admin?.isActive !== false;
  const name = `${admin?.firstName || ""} ${admin?.lastName || ""}`.trim();

  const mutation = useMutation(updateAdminStatus, {
    onSuccess: () => {
      queryClient.invalidateQueries("admin-users");
      toast.success(isActive ? "Admin deactivated" : "Admin activated");
      setOpen(false);
    },
    onError: (e) => {
      toast.error(e.message);
    },
  });

  if (!getModulePermission("admin", "canUpdate")) return null;

  return (
    <>
      <Button size="small" danger={isActive} onClick={() => setOpen(true)}>
        {isActive ? "Deactivate" : "Activate"}
      </Button>
      <Modal
        title={`${isActive ? "Deactivate" : "Activate"} ${name || "admin"}?`}
        open={open}
        onCancel={() => !mutation.isLoading && setOpen(false)}
        okText={isActive ? "Deactivate" : "Activate"}
        okButtonProps={{ danger: isActive, loading: mutation.isLoading }}
        onOk={() => mutation.mutate({ id: admin._id, isActive: !isActive })}
      >
        <p className="text-[13px]">
          {isActive
            ? "They will lose access to the admin dashboard."
            : "They will regain access with their current role."}
        </p>
      </Modal>
    </>
  );
}
